import { render } from "./rewardSelector.vue?vue&type=template&id=bfd135cc&scoped=true"
import script from "./rewardSelector.vue?vue&type=script&lang=js"
export * from "./rewardSelector.vue?vue&type=script&lang=js"

import "./rewardSelector.vue?vue&type=style&index=0&id=bfd135cc&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd135cc"]])

export default __exports__